// extracted by css-extract-rspack-plugin
export default {"wrapper":"_3fef5976","fullscreen":"_c5fa03a","controlList":"_295a39c0","focus":"_bf790429"};